import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">
        <path d="M5067 7560 c-20 -4 -40 -10 -43 -13 -7 -7 58 2 96 14 33 10 0 10 -53
-1z"/>
<path d="M5151 7556 c2 -2 20 -6 39 -10 25 -4 31 -3 20 4 -14 9 -69 15 -59 6z"/>
<path d="M4950 7520 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M5260 7526 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M4910 7490 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"/>
<path d="M5310 7496 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M5401 7390 c14 -31 19 -36 19 -24 0 6 -7 19 -16 30 -14 18 -14 18 -3
-6z"/>
<path d="M4786 7289 c-3 -17 -5 -50 -5 -73 1 -30 4 -23 10 29 8 74 6 97 -5 44z"/>
<path d="M5441 7294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5447 7211 c-4 -18 -7 -43 -6 -55 1 -11 5 -1 10 24 5 25 7 49 6 55
-2 5 -7 -5 -10 -24z"/>
<path d="M3050 7197 c0 -3 105 -189 234 -414 128 -224 327 -572 441 -773 114
-201 224 -394 244 -430 21 -36 93 -164 162 -285 114 -203 131 -227 214 -311
146 -148 286 -212 480 -221 93 -5 124 -2 194 16 174 45 311 134 416 270 34 45
215 360 215 376 0 1 34 65 76 141 124 226 155 286 151 290 -2 2 -16 -19 -31
-46 -66 -122 -246 -249 -404 -286 -91 -22 -245 -15 -326 14 -137 49 -269 153
-353 278 -35 52 -84 133 -220 367 -39 68 -86 148 -139 239 -21 36 -93 160
-159 274 -108 187 -129 218 -210 300 -94 95 -156 136 -265 175 -62 22 -80 23
-392 27 -181 2 -328 1 -328 -1z"/>
<path d="M6091 7179 c-18 -6 -31 -12 -29 -14 2 -3 20 0 39 5 18 6 130 10 246
10 196 0 213 -1 213 -17 0 -15 2 -16 10 -3 5 8 10 18 10 22 0 11 -451 8 -489
-3z"/>
<path d="M4790 7149 c0 -13 5 -31 10 -39 7 -11 8 -5 4 20 -8 43 -14 51 -14 19z"/>
<path d="M5995 7141 c-22 -11 -35 -19 -30 -19 14 -1 93 36 80 37 -5 0 -28 -8
-50 -18z"/>
<path d="M6525 7099 c-10 -30 -2 -32 12 -3 6 13 7 24 3 24 -5 0 -12 -9 -15
-21z"/>
<path d="M5410 7080 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M5876 7075 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z"/>
<path d="M6490 7029 c-7 -11 -10 -23 -7 -25 2 -2 9 7 15 21 14 30 7 33 -8 4z"/>
<path d="M4872 7000 c7 -11 17 -20 22 -20 5 0 1 9 -9 20 -10 11 -20 20 -22 20
-2 0 2 -9 9 -20z"/>
<path d="M5779 6983 l-34 -38 38 34 c34 33 42 41 34 41 -2 0 -19 -17 -38 -37z"/>
<path d="M5270 6940 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M4980 6927 c0 -3 15 -10 32 -16 18 -6 28 -7 23 -2 -12 10 -55 25 -55
18z"/>
<path d="M5210 6914 c-33 -13 -33 -14 -5 -8 17 3 34 10 40 15 11 11 8 11 -35
-7z"/>
<path d="M5098 6893 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M6391 6839 c-7 -12 -10 -23 -8 -26 3 -3 11 5 17 17 15 28 8 35 -9 9z"/>
<path d="M5666 6833 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M5635 6784 c-9 -14 -14 -28 -12 -31 3 -3 13 9 22 26 19 38 14 41 -10
5z"/>
<path d="M6355 6769 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5570 6674 c-17 -31 -30 -58 -28 -60 2 -2 19 24 37 56 18 33 30 60
28 60 -3 0 -19 -25 -37 -56z"/>
<path d="M6320 6699 c-7 -11 -10 -23 -7 -25 2 -2 9 7 15 21 14 30 7 33 -8 4z"/>
<path d="M6290 6645 c-7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 7 9 11 18 8 20 -3
3 -11 -1 -18 -10z"/>
<path d="M6245 6559 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5476 6513 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M6190 6454 c-12 -19 -21 -37 -18 -39 2 -2 14 14 26 36 28 49 22 52
-8 3z"/>
<path d="M5426 6433 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M6145 6369 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5385 6359 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5355 6319 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M6101 6290 c-5 -16 -8 -30 -6 -30 2 0 10 14 19 30 8 17 11 30 6 30
-4 0 -13 -13 -19 -30z"/>
<path d="M5311 6242 c-17 -31 -13 -40 5 -14 9 13 14 26 11 29 -3 2 -10 -4 -16
-15z"/>
<path d="M6076 6233 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M6045 6180 c-9 -16 -13 -30 -11 -30 3 0 12 14 21 30 9 17 13 30 11
30 -3 0 -12 -13 -21 -30z"/>
<path d="M6015 6129 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5236 6113 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M5982 6064 c-12 -19 -19 -34 -15 -34 8 0 46 61 41 66 -2 1 -13 -13
-26 -32z"/>
<path d="M5186 6033 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M5940 5990 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M5146 5965 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M5100 5890 c-11 -22 -18 -40 -15 -40 2 0 14 18 25 40 11 22 18 40 15
40 -2 0 -14 -18 -25 -40z"/>
<path d="M5886 5883 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M5065 5829 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5055 5720 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M5110 5675 c0 -7 81 -47 86 -43 2 3 -17 14 -41 26 -25 12 -45 20 -45
17z"/>
<path d="M5605 5620 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M5265 5600 c19 -8 73 -14 64 -6 -2 2 -22 6 -44 9 -28 5 -34 4 -20 -3z"/>
<path d="M5558 5603 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5518 5593 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5367 5583 c18 -2 50 -2 70 0 21 2 7 4 -32 4 -38 0 -55 -2 -38 -4z"/>
<path d="M1620 4356 c0 -5 180 -471 260 -676 39 -96 105 -267 148 -380 l78
-205 145 -3 145 -3 82 208 c44 115 107 273 137 353 31 80 90 228 130 330 86
217 145 370 145 376 0 2 -63 4 -140 4 -103 0 -140 -3 -140 -12 0 -13 -119
-349 -247 -698 -42 -113 -83 -227 -91 -255 -15 -46 -17 -48 -20 -20 -3 23
-311 866 -352 963 -9 21 -14 22 -145 22 -74 0 -135 -2 -135 -4z"/>
<path d="M4755 4350 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4818 4353 c23 -2 59 -2 80 0 20 2 1 4 -43 4 -44 0 -61 -2 -37 -4z"/>
<path d="M5003 4353 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5756 4352 c-2 -4 13 -6 35 -4 21 2 39 6 39 8 0 7 -69 4 -74 -4z"/>
<path d="M5883 4353 c26 -2 68 -2 95 0 26 2 4 3 -48 3 -52 0 -74 -1 -47 -3z"/>
<path d="M6042 3743 c-1 -336 -5 -620 -8 -630 -5 -16 -4 -16 5 -1 8 11 10 202
8 630 l-2 613 -3 -612z"/>
<path d="M5050 4298 c0 -9 5 -20 10 -23 13 -8 13 5 0 25 -8 13 -10 13 -10 -2z"/>
<path d="M5716 4275 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M3050 4139 l0 -110 -77 2 -78 2 -3 -91 -3 -92 81 0 80 0 0 -273 c0
-322 6 -357 74 -423 27 -26 61 -46 92 -55 61 -17 203 -16 264 3 l45 14 3 92
c1 51 1 92 -1 92 -3 0 -21 -7 -40 -15 -44 -18 -103 -19 -137 -2 -54 27 -60 59
-60 325 l0 242 120 0 121 0 -3 93 -3 92 -117 -1 -118 -1 0 108 0 109 -120 0
-120 0 0 -111z"/>
<path d="M7251 4218 c2 -30 2 -31 6 -5 l4 27 104 0 104 0 4 -77 3 -78 0 80 -1
80 -112 3 -113 3 1 -33z"/>
<path d="M5097 4200 c3 -11 9 -22 13 -25 5 -3 6 4 3 15 -3 11 -9 22 -13 25 -5
3 -6 -4 -3 -15z"/>
<path d="M5675 4179 c-9 -17 -15 -33 -13 -35 3 -2 12 12 21 31 21 43 13 47 -8
4z"/>
<path d="M5646 4113 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M7251 4064 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5607 4035 c-24 -50 -20 -58 4 -12 11 22 19 41 17 43 -3 2 -12 -12
-21 -31z"/>
<path d="M5170 4040 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z"/>
<path d="M6590 4050 l-55 -7 50 -1 c28 0 59 3 70 8 23 10 14 10 -65 0z"/>
<path d="M8213 4053 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M6735 4040 c11 -5 27 -9 35 -9 9 0 8 4 -5 9 -11 5 -27 9 -35 9 -9 0
-8 -4 5 -9z"/>
<path d="M8076 4034 c-71 -22 -51 -26 24 -4 36 10 56 19 45 19 -11 0 -42 -7
-69 -15z"/>
<path d="M8330 4030 c30 -11 57 -20 60 -19 12 2 -77 38 -95 38 -11 0 5 -9 35
-19z"/>
<path d="M3672 3668 c3 -355 4 -375 24 -419 32 -69 77 -113 146 -144 52 -23
77 -28 148 -29 118 -1 179 22 247 90 l53 53 0 -65 0 -64 120 0 120 0 0 475 0
475 -119 0 -120 0 -3 -312 c-3 -276 -5 -317 -21 -345 -53 -98 -174 -139 -274
-94 -77 35 -78 40 -81 419 l-3 332 -120 0 -120 0 3 -372z"/>
<path d="M6493 4033 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M7116 4032 c-2 -4 14 -6 37 -4 68 5 76 10 20 11 -28 0 -54 -2 -57 -7z"/>
<path d="M7538 4033 c29 -2 74 -2 100 0 26 2 2 3 -53 3 -55 0 -76 -1 -47 -3z"/>
<path d="M6438 4013 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6395 4000 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M7970 3985 c-19 -14 -30 -25 -24 -25 10 1 73 50 63 50 -3 0 -20 -11
-39 -25z"/>
<path d="M6870 3975 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25
-28 25 -3 0 5 -11 18 -25z"/>
<path d="M4990 3985 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M6354 3974 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z"/>
<path d="M4965 3540 c0 -245 1 -345 2 -223 2 123 2 323 0 445 -1 123 -2 23 -2
-222z"/>
<path d="M5822 3955 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M8474 3945 c21 -19 40 -35 43 -35 2 0 -10 16 -28 35 -19 19 -38 35
-43 35 -5 0 8 -16 28 -35z"/>
<path d="M5210 3954 c0 -6 7 -19 16 -30 14 -18 14 -18 3 6 -14 31 -19 36 -19
24z"/>
<path d="M5562 3935 c-17 -37 -14 -45 4 -12 9 16 14 31 11 33 -2 2 -9 -7 -15
-21z"/>
<path d="M6302 3944 c-18 -12 -22 -24 -20 -62 l1 -47 4 45 c3 31 11 50 26 62
27 22 19 23 -11 2z"/>
<path d="M7904 3928 l-19 -23 23 19 c12 11 22 21 22 23 0 8 -8 2 -26 -19z"/>
<path d="M5010 3931 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M5766 3925 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M6921 3923 c7 -12 15 -20 18 -17 3 2 -3 12 -13 22 -17 16 -18 16 -5
-5z"/>
<path d="M5823 3885 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M5030 3895 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M5240 3895 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M7861 3877 c-13 -21 -12 -21 5 -5 10 10 16 20 13 22 -3 3 -11 -5 -18
-17z"/>
<path d="M8543 3861 c12 -22 23 -38 25 -36 5 5 -26 63 -37 69 -5 4 0 -12 12
-33z"/>
<path d="M5527 3861 c-9 -16 -17 -33 -17 -38 0 -4 9 7 21 26 11 18 18 35 17
37 -2 2 -12 -10 -21 -25z"/>
<path d="M6950 3885 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M6548 3873 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z"/>
<path d="M8178 3873 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M6488 3863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7110 3860 c8 -5 26 -10 39 -10 32 0 24 6 -19 14 -25 4 -31 3 -20 -4z"/>
<path d="M7590 3860 l-85 -6 88 -2 c52 -1 87 2 87 8 0 6 -1 9 -2 8 -2 -1 -41
-5 -88 -8z"/>
<path d="M8105 3860 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M5266 3837 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M6430 3840 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M7835 3839 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5825 3480 c0 -201 1 -283 2 -182 2 100 2 264 0 365 -1 100 -2 18 -2
-183z"/>
<path d="M7253 3800 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M7472 3594 c-2 -215 0 -253 14 -270 8 -10 12 -12 7 -4 -4 8 -10 130
-13 270 l-6 255 -2 -251z"/>
<path d="M8330 3836 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M5716 3815 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M6750 3811 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M5087 3775 c9 -19 18 -33 21 -31 4 5 -26 66 -33 66 -3 0 3 -16 12
-35z"/>
<path d="M5281 3805 c0 -5 6 -21 14 -35 8 -14 14 -20 14 -15 0 6 -6 21 -14 35
-8 14 -14 21 -14 15z"/>
<path d="M5501 3794 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6981 3794 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8022 3775 c-17 -37 -14 -45 4 -12 9 16 14 31 11 33 -2 2 -9 -7 -15
-21z"/>
<path d="M8372 3778 c7 -15 15 -23 17 -17 2 6 -4 18 -13 27 -15 15 -15 15 -4
-10z"/>
<path d="M6281 3774 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7806 3765 c-3 -9 -6 -22 -5 -28 0 -7 5 -1 10 12 5 13 8 26 5 28 -2
2 -6 -3 -10 -12z"/>
<path d="M6992 3740 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M4741 3744 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6781 3723 c-1 -23 3 -44 7 -47 4 -2 6 12 4 32 -5 56 -10 62 -11 15z"/>
<path d="M5316 3727 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M5466 3725 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M5671 3713 c-10 -26 -10 -27 4 -9 8 11 15 23 15 28 0 15 -7 8 -19
-19z"/>
<path d="M8391 3724 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8591 3724 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8002 3705 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M7786 3698 c-3 -13 -5 -34 -5 -48 1 -15 5 -7 10 19 9 47 6 68 -5 29z"/>
<path d="M5120 3691 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M7004 3410 c0 -162 2 -229 3 -147 2 81 2 213 0 295 -1 81 -3 14 -3
-148z"/>
<path d="M5146 3647 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M6486 3649 c-27 -4 -54 -13 -60 -19 -8 -8 -2 -8 19 0 17 7 95 15 175
19 l145 8 -115 0 c-63 0 -137 -3 -164 -8z"/>
<path d="M8112 3653 c37 -2 100 -2 140 0 40 1 10 3 -67 3 -77 0 -110 -1 -73
-3z"/>
<path d="M8353 3653 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M5360 3635 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M8611 3624 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5160 3619 c0 -3 9 -23 20 -45 12 -22 18 -28 14 -14 -6 23 -34 71
-34 59z"/>
<path d="M5616 3604 c-4 -9 -4 -19 -1 -22 2 -3 7 3 11 12 4 9 4 19 1 22 -2 3
-7 -3 -11 -12z"/>
<path d="M7773 3560 c0 -36 2 -50 4 -32 2 17 2 47 0 65 -2 17 -4 3 -4 -33z"/>
<path d="M6329 3583 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M7253 3520 c0 -47 2 -66 4 -42 2 23 2 61 0 85 -2 23 -4 4 -4 -43z"/>
<path d="M8613 3565 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M6285 3549 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M5581 3523 c-7 -8 -11 -16 -8 -19 2 -2 10 2 17 11 17 20 9 27 -9 8z"/>
<path d="M6247 3503 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M6578 3503 c28 -2 76 -2 105 0 28 2 5 3 -53 3 -58 0 -81 -1 -52 -3z"/>
<path d="M8143 3503 c82 -2 212 -2 290 0 78 1 12 3 -148 3 -159 0 -223 -2
-142 -3z"/>
<path d="M8588 3503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5220 3495 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M6490 3490 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M5552 3465 c-17 -37 -14 -45 4 -12 9 16 14 31 11 33 -2 2 -9 -7 -15
-21z"/>
<path d="M7782 3465 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M7992 3465 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M5240 3445 c0 -3 4 -13 9 -23 6 -9 20 -38 32 -64 12 -27 25 -46 27
-43 3 2 -2 15 -10 27 -8 13 -20 40 -27 60 -11 32 -31 61 -31 43z"/>
<path d="M6221 3424 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6782 3410 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M5526 3405 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M7791 3404 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8001 3404 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6213 3355 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"/>
<path d="M6422 3375 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M6771 3364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7800 3368 c0 -9 5 -20 10 -23 13 -8 13 5 0 25 -8 13 -10 13 -10 -2z"/>
<path d="M8486 3362 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M5496 3345 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M7251 3324 c0 -21 4 -48 9 -59 5 -12 6 1 3 35 -7 66 -13 79 -12 24z"/>
<path d="M6431 3329 c-1 -9 9 -24 22 -35 22 -19 22 -19 6 1 -9 11 -19 27 -22
35 -5 13 -6 13 -6 -1z"/>
<path d="M6732 3310 c-18 -17 -29 -30 -24 -30 5 0 21 14 37 30 37 38 30 38
-13 0z"/>
<path d="M8521 3323 c7 -12 15 -20 18 -17 3 2 -3 12 -13 22 -17 16 -18 16 -5
-5z"/>
<path d="M5475 3299 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M8410 3300 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M5310 3288 c0 -5 35 -7 78 -7 78 2 69 6 -26 11 -28 2 -52 0 -52 -4z"/>
<path d="M7830 3291 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M7698 3209 c3 -60 0 -84 -10 -91 -10 -8 -10 -9 2 -5 12 3 16 23 18
90 1 48 -1 87 -5 87 -4 0 -7 -37 -5 -81z"/>
<path d="M8355 3280 c-13 -6 -15 -9 -5 -9 8 0 22 4 30 9 18 12 2 12 -25 0z"/>
<path d="M7558 3273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7628 3273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8157 3269 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6511 3256 c2 -2 22 -6 44 -9 28 -5 34 -4 20 3 -19 8 -73 14 -64 6z"/>
<path d="M6618 3253 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M8198 3253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8248 3253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8574 3240 c0 -13 4 -16 10 -10 7 7 7 13 0 20 -6 6 -10 3 -10 -10z"/>
<path d="M7860 3246 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M7890 3206 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M8505 3174 c-18 -16 -22 -22 -9 -15 18 9 53 42 43 41 -2 -1 -17 -12
-34 -26z"/>
<path d="M6280 3170 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6791 3164 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7315 3160 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M7941 3167 c2 -2 20 -14 39 -26 l35 -23 -30 26 c-16 14 -34 26 -39
26 -5 0 -7 -1 -5 -3z"/>
<path d="M6791 3123 c-1 -21 3 -23 47 -21 l47 1 -42 4 c-29 3 -43 9 -46 21 -3
12 -5 11 -6 -5z"/>
<path d="M7357 3119 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6630 3110 c-21 -7 -21 -8 -5 -9 11 0 27 4 35 9 18 11 5 11 -30 0z"/>
<path d="M8059 3106 c18 -9 43 -16 55 -15 16 1 14 3 -9 9 -72 20 -80 21 -46 6z"/>
<path d="M5868 3103 c28 -2 76 -2 105 0 28 2 5 3 -53 3 -58 0 -81 -1 -52 -3z"/>
<path d="M6397 3099 c13 -13 145 -21 178 -10 25 8 20 9 -25 4 -30 -3 -79 -1
-108 5 -30 5 -50 6 -45 1z"/>
<path d="M7419 3096 c21 -10 58 -15 100 -14 l66 1 -75 7 c-41 4 -86 10 -100
14 -15 4 -11 1 9 -8z"/>
<path d="M7608 3093 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M8328 3093 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8183 3083 c20 -2 54 -2 75 0 20 2 3 4 -38 4 -41 0 -58 -2 -37 -4z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
